import { Avatar, Box, Checkbox, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../../../theme/palette";
import { VerificationIcon } from "../../../../../assets/icons/MUI/NetworkIcons";
import { UserInfo } from "../../../../../types";
import { useProfileData } from "../../../../../hooks/useProfileData";
import { useDataFormatter } from "../../../../../hooks/useDataFormatter";
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

const SearchUserCard = ({
  user,
  isLast,
  membersList,
  setMembersList,
  handleRemoveUser,
}: {
  user: UserInfo;
  isLast: boolean;
  membersList: UserInfo[];
  setMembersList: Dispatch<SetStateAction<UserInfo[]>>;
  handleRemoveUser: (user: UserInfo | null) => void;
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const {
    fullName,
    firstTwoChr,
    isVerified,
    media,
    role,
    profileLink,
    mutualFollowersCount,
    playerPositionShort,
    friendsCount,
    id,
    entityId,
  } = useDataFormatter(user);

  const [isOnTheList, setIsOnTheList] = useState(membersList.find((member) => member.id === id));

  useEffect(() => {
    setIsOnTheList(membersList.find((member) => member.id === id));
  }, [membersList]);

  const { data: ownProfileData } = useProfileData();
  const { entityId: entityIdFromCache } = ownProfileData;

  const isOwnProfile = entityId == entityIdFromCache && entityIdFromCache != null;

  const handleCheck = () => {
    if (isOnTheList) {
      //   setMembersList((prevList) => prevList.filter((member: UserInfo) => member.id !== id));
      handleRemoveUser(user);
    } else {
      setMembersList((prevList) => [...prevList, user]);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        columnGap: "20px",
        paddingBottom: isLast ? "0" : "16px",
        marginBottom: isLast ? "0" : "16px",
        borderBottom: isLast ? "unset" : "1px solid #EAECF0",
      }}
    >
      <Checkbox
        sx={{
          width: "fit-content",
          height: "fit-content",
        }}
        onClick={handleCheck}
        checked={!!isOnTheList}
      />
      <Avatar
        sx={{
          width: "72px",
          height: "72px",
          position: "relative",
        }}
        src={media}
      >
        {firstTwoChr}
        {isVerified && (
          <VerificationIcon
            sx={{
              position: "absolute",
              bottom: "-6px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: "10",
            }}
          />
        )}
      </Avatar>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <Link
          sx={{
            textDecoration: "none",
            color: colors.dark1000,
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "normal",
            maxWidth: "80%",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            cursor: "pointer",
          }}
          onClick={() => navigate(profileLink)}
        >
          {fullName}
        </Link>
        <Typography
          component="span"
          variant="body12Regular"
          sx={{
            color: colors.Dark1000,
          }}
        >
          {role}
          {playerPositionShort ? ` . (${playerPositionShort})` : ""}
        </Typography>

        <Typography
          component="span"
          variant="body12Regular"
          sx={{
            color: colors.Dark600,
          }}
        >
          {friendsCount ? `${friendsCount} ${t("components.networkController.userCard.friends")}` : ""}
        </Typography>

        {isOwnProfile ? (
          <></>
        ) : (
          <Typography
            component="span"
            variant="body12Regular"
            sx={{
              color: colors.Dark600,
            }}
          >
            {`${mutualFollowersCount} ${t("components.networkController.userCard.commonFollowers")}`}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SearchUserCard;
